import { PATH_TO_USER_TYPE_STATE } from "../consts";
import { UserType } from "../model/UserType";

export function getUserType(state: any): UserType {
  return state.get(PATH_TO_USER_TYPE_STATE);
}
